import { useFetchAllQueries } from 'shared/base/hooks/useFetchAllQueries';

import { BarChart } from './barChart';
import { mapBarChartData } from '../../mappers';
import { BarChartVariant, ReportCardVariantProps } from '../../types';
import { ReportCardWrapper } from '../cardWrapper';
import { BarChartLoader } from './barChartLoader';

interface AdditionalProps {
  variantProps: BarChartVariant;
}

export const BarChartReportCard = ({
  clearFilters,
  columnFormatter,
  description,
  query,
  sx,
  title,
  variantProps,
}: ReportCardVariantProps & AdditionalProps) => {
  const queryResult = useFetchAllQueries(query);

  return (
    <ReportCardWrapper
      clearFilters={clearFilters}
      description={description}
      query={query.baseQuery}
      queryResult={queryResult}
      renderContent={(successfulResult) => {
        const mappedData = mapBarChartData(successfulResult.data, columnFormatter);

        return <BarChart data={mappedData} entryLabel={variantProps?.entryLabel} />;
      }}
      renderLoading={() => <BarChartLoader />}
      sx={sx}
      title={title}
    />
  );
};
